import React from 'react';
import { Button } from '@mui/material';
import { Icons } from 'components/Icons';

export default function GoogleSignUpButton({
  onClick,
  href,
  style,
  variant = 'default',
  ...props
}) {
  return (
    <Button
      variant="outlined"
      fullWidth
      onClick={onClick}
      href={href}
      style={{
        border: '1px solid #616161', // Purple border as in screenshot
        borderRadius: 40,
        background: '#ffffff',
        color: '#444',
        fontWeight: 200,
        fontSize: 14,
        height: 48,
        textTransform: 'none',
        boxShadow: '0 2px 8px rgba(60,64,67,.12)',
        padding: '0px 6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...props}
    >
      <Icons.googleColored width={24} height={24} />
      <span style={{ fontSize: 14, fontWeight: 600, marginLeft: 4, fontFamily: 'Lato' }}>
        Sign up with Google
      </span>
    </Button>
  );
}
